<template>
  <v-navigation-drawer
    v-model="drawerState"
    :color="colorBackground"
    :mini-variant="sidebarState"
    app
    :mobile-breakpoint="mobileBreakpoint"
    width="250"
    class="sv-navigation-drawer"
    :expand-on-hover="sidebarState"
  >
    <v-list class="pb-0 pt-0">
      <product-title list-item :title="title" class="sv-logo-container" />
    </v-list>
    <vue-custom-scrollbar
      class="sv-aside-scroll-area"
      :settings="scrollBarSettings"
    >
      <v-list>
        <sidebar-nav-item
          v-for="navItem in navMenu"
          :key="`${navItem.kind}-${navItem.id}`"
          :ref="`ref_navitem_${navItem.id}`"
          :nav-item="navItem"
          @activateNode="onPropagateActivateNode"
        />
      </v-list>
    </vue-custom-scrollbar>
    <sidebar-footer v-if="!sidebarState" />
  </v-navigation-drawer>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import ProductTitle from "./../ProductTitle/ProductTitle";
import SidebarNavItem from "./SidebarNavItem";
import SidebarFooter from "./../Footer/Footer.vue";
import "./Sidebar.scss";

export default {
  name: "Sidebar",
  components: {
    vueCustomScrollbar,
    ProductTitle,
    SidebarNavItem,
    SidebarFooter
  },
  props: {
    title: {
      type: String,
      default: null
    },
    titleLightLength: {
      type: Number,
      default: null
    },
    colorBackground: {
      type: String,
      default: "#2e323a"
    },
    consumer: {
      type: String,
      default: null
    }
  },
  data: () => ({
    scrollBarSettings: {
      suppressScrollX: true,
      maxScrollbarLength: 100
    },
    drawerState: true,
    windowWidth: window.innerWidth,
    mobileBreakpoint: 1264
  }),
  computed: {
    navMenu() {
      return this.$store.getters.getNavMenu;
    },
    sidebarState: {
      get() {
        if (this.windowWidth >= this.mobileBreakpoint) {
          return this.$store.getters.getSidebar;
        } else {
          return false;
        }
      },
      set(value) {
        this.$store.commit("setSidebar", value);
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.onUpdateWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onUpdateWidth);
  },
  methods: {
    // Когда получаем событие активации от дочернего элемента меню, который куда-то ведёт,
    // то надо закрыть все соседние раскрытые дочерние вкладки, иначе выглядит слегка некошерно
    onPropagateActivateNode() {
      this.navMenu.forEach(item => {
        if (item?.children?.length) {
          // если это вкладка
          this.$refs[`ref_navitem_${item.id}`][0].collapse();
        }
      });
    },
    refCallSidebar() {
      this.drawerState = true;
    },
    onUpdateWidth() {
      this.windowWidth = window.innerWidth;
    }
  }
};
</script>
